import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { FormRequestItbiComponent } from './form-request-itbi/form-request-itbi.component';
import { FormRequestSeadComponent } from './form-request-sead/form-request-sead.component';
import { ComponentsModule } from 'src/app/components/components.module';
import { GerinusToolsModule } from '../../lib/gerinus-tools.module';
import { FormRequestDefaultComponent } from './form-request-default/form-request-default.component';
import { FormRequestIptuComponent } from './form-request-iptu/form-request-iptu.component';
import { ApplicationItbiComponent } from './form-request-itbi/application-itbi/application-itbi.component';
import { FormRequestInscricaoMunicipalComponent } from './form-request-inscricao-municipal/form-request-inscricao-municipal.component';
import { RequestItbiComponent } from './form-request-itbi/request-itbi/request-itbi.component';
import { FormRequestAlvaraComponent } from './form-request-alvara/form-request-alvara.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FormRequestSemurbComponent } from './form-request-semurb/form-request-semurb.component';
import { FormRequestDynamicComponent } from './form-request-dynamic/form-request-dynamic.component';

const components = [
  FormRequestDefaultComponent,
  FormRequestItbiComponent,
  FormRequestSeadComponent,
  FormRequestIptuComponent,
  ApplicationItbiComponent,
  RequestItbiComponent,
  FormRequestInscricaoMunicipalComponent,
  FormRequestSemurbComponent,
  FormRequestAlvaraComponent,
  FormRequestDynamicComponent
];

@NgModule({
  declarations: components,
  exports: components,
  imports: [
    CommonModule,
    ComponentsModule,
    GerinusToolsModule,
    ReactiveFormsModule,
    AutoCompleteModule
  ]
})
export class FormsModule { }
